/* eslint-disable */
export default {
  dial: 'Valitse',
  message: 'Viesti',
  transfer: 'Siirrä',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
